import React from 'react'
import Header from './Reusables/Header'
import DownloadImg from "../assests/download.svg";
import SkuTable from './Tables/SkuTable';
import axiosRequest from "../api/axios";
import SnackBarComponent from "./Helpers/SnackBarComponent";
import CircularProgress from "@mui/material/CircularProgress";
import { CSVLink } from "react-csv";
import ABMSkuTable from './Tables/ABMSkuTable';
import PeriodSelector from './PeriodSelector';

const ABMSkuSummary = () => {
  const [filtersData, setfiltersData] = React.useState({});
  const [RbmListData, setRbmListData] = React.useState([]);
  const [brandListData, setbrandListData] = React.useState([]);
  const [selectedRbm, setselectedRbm] = React.useState("");
  const [productListData, setproductListData] = React.useState([]);
  const [selectedProduct, setselectedProduct] = React.useState("");
  const [selectedBrand, setselectedBrand] = React.useState("");
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [filtersOutputData, setfiltersOutputData] = React.useState({});
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [rows, setrows] = React.useState([]);
  const [Month1, setMonth1] = React.useState("");
  const [Month2, setMonth2] = React.useState("");
  const [Month3, setMonth3] = React.useState("");
  const [Quarter, setQuarter] = React.useState("");
  const [loaderFilter, setLoaderFilter] = React.useState(false);
  const [filtersDataSum, setfiltersDataSum] = React.useState({});

  const api_headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+localStorage.getItem("Token")
  }
  let sum_data = {
    m1_adj_unit : 0, 
        m1_adj_val :0, 
        m2_adj_unit : 0, 
        m2_adj_val :0, 
        m3_adj_unit : 0, 
        m3_adj_val :0, 
  }
  let RbmListComponent = [];
  RbmListData.forEach((item, index) => {
    RbmListComponent.push(<option key={index}>{item}</option>);
  });
  let brandComponent = [];
  brandListData.forEach((item, index) => {
    brandComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
 
  let productComponent = [];
  productListData.forEach((item, index) => {
    productComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
  const handleChangeBrand = (event) => {
    setselectedBrand(event.target.value);
   
  };
  const handleChangeRbm = (event) => {
    setselectedRbm(event.target.value);
   
  };

  

  
 
  const handleClose = () => {
    setOpensb(false);
  };
 

  
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };

  const handleApply = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/getabmsummarydata/",
      method: "POST",
      headers: api_headers,

      data: {
        repname: selectedRbm,
        brandname: selectedBrand,
        team: localStorage.getItem("teamcode"),
        abmcode: localStorage.getItem("abmcode"),
        year:localStorage.getItem('year'),
        quarter:localStorage.getItem('quarter'),
      },
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        setrows(data?.data?.data);
        let tot_data = data?.data?.data
        let m1_adj_unit = 0 
        let m1_adj_val =0 
        let m2_adj_unit = 0 
        let m2_adj_val =0 
        let m3_adj_unit = 0 
        let m3_adj_val =0 
        
        for (let i = 0; i < tot_data?.length; i++) { 
          
          m1_adj_unit = m1_adj_unit+ parseFloat(tot_data[i]["sum_m1_adjusted_budget_unit"] != null ? tot_data[i]["sum_m1_adjusted_budget_unit"] : 0)
          m1_adj_val = m1_adj_val + parseFloat(tot_data[i]["sum_m1_adjusted_budget_value"] != null ? tot_data[i]["sum_m1_adjusted_budget_value"] : 0)
          m2_adj_unit = m2_adj_unit+ parseFloat(tot_data[i]["sum_m2_adjusted_budget_unit"] != null ? tot_data[i]["sum_m2_adjusted_budget_unit"] : 0)
          m2_adj_val = m2_adj_val + parseFloat(tot_data[i]["sum_m2_adjusted_budget_value"] != null ? tot_data[i]["sum_m2_adjusted_budget_value"] : 0)
          m3_adj_unit = m3_adj_unit+ parseFloat(tot_data[i]["sum_m3_adjusted_budget_unit"] != null ? tot_data[i]["sum_m3_adjusted_budget_unit"] : 0)
          m3_adj_val = m3_adj_val + parseFloat(tot_data[i]["sum_m3_adjusted_budget_value"] != null ? tot_data[i]["sum_m3_adjusted_budget_value"] : 0)

        }
     
        sum_data['m1_adj_unit'] = parseFloat(m1_adj_unit).toFixed( 2 );
        sum_data['m1_adj_val'] = parseFloat(m1_adj_val).toFixed( 2 );
        sum_data['m2_adj_unit'] = parseFloat(m2_adj_unit).toFixed( 2 );
        sum_data['m2_adj_val'] = parseFloat(m2_adj_val).toFixed( 2 );
         sum_data['m3_adj_unit'] = parseFloat(m3_adj_unit).toFixed( 2 );
        sum_data['m3_adj_val'] = parseFloat(m3_adj_val).toFixed( 2 );
        setfiltersDataSum(sum_data)
        handleSnackBar("Data Loaded Successfully", "success");
        // setfiltersOutputData()
       
      } else {
        
        handleSnackBar("Something went wrong! ", "error");
      }
    });
  };


  const getfiltersdata = async () => {
    setLoaderFilter(true);
    await axiosRequest({
      url: "bu_head_app/filterabmsummary/",
      method: "POST",
      headers: api_headers,

      data: {
        team: localStorage.getItem("teamcode"),
        abmcode:localStorage.getItem('abmcode'),
        year:localStorage.getItem('year'),
        quarter:localStorage.getItem('quarter'),

      },
    }).then((data) => {
      if (data.status === 200) {
        const temp_list = ["All"];
        const brand_list=["All"]
        setfiltersData(data?.data?.data);
        for(let item in data?.data?.data["repname"]){
          temp_list.push(data?.data?.data["repname"][item])
        }
        for(let item in data?.data?.data["brand"]){
          brand_list.push(data?.data?.data["brand"][item])
        }
        setRbmListData(temp_list);
        // console.log(RbmListData,"---------")
        setbrandListData(brand_list)
        setdataLoaded(true);
        setLoaderFilter(false);
      } else {
        // setLoader(false);
        // handleSnackBar("No Data Found", "error");
        setdataLoaded(false);
        setLoaderFilter(false);
       
      }
    });
  };
  React.useEffect(() => {
    getfiltersdata();
    setQuarter(localStorage.getItem('quarter'))
    //logic to display month name based on Quarter
    if (localStorage.getItem('quarter') == "Q1") {
      setMonth1("Jan");
      setMonth2("Feb");
      setMonth3("Mar");
    } else if (localStorage.getItem('quarter') == "Q2") {
      setMonth1("Apr");
      setMonth2("May");
      setMonth3("Jun");
    } else if (localStorage.getItem('quarter') == "Q3") {
      setMonth1("Jul");
      setMonth2("Aug");
      setMonth3("Sep");
    } else if (localStorage.getItem('quarter') == "Q4") {
      setMonth1("Oct");
      setMonth2("Nov");
      setMonth3("Dec");
    }
    // gettabledata();
  }, []);

  let columns_buh = [
    { key: "id", label: "ID"},
    {
        key: 'repname',
        label: 'REP Name',
        
      },
    {
      key: 'brand',
      label: 'Brand',
      
    },
    {
      key: 'sum_m1_adjusted_budget_unit',
      label: String(Month1)+' Bug Unit',
     
    },
    {
      key: 'sum_m1_adjusted_budget_value',
      label: String(Month1)+' Bug Val',
      
    },
    {
      key: 'sum_m2_adjusted_budget_unit',
      label: String(Month2)+' Bug Unit',
     
    },
    {
      key: 'sum_m2_adjusted_budget_value',
      label: String(Month2)+' Bug Val',
      
    },
    {
      key: 'sum_m3_adjusted_budget_unit',
      label: String(Month3)+' Bug Unit',
     
    },
    {
      key: 'sum_m3_adjusted_budget_value',
      label: String(Month3)+' Bug Val',
      
    }
  ];
 
  
  return (
    <div className='bg-white home-screen'>
      <p style={{fontWeight:"550"}}>Brand Summary</p>
      <PeriodSelector/>
       <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", marginRight: "30px", marginBottom: "20px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "5px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              REP Name
            </label>
            <select
              className="filter-style"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeRbm(event)}
            >
              {loaderFilter === true ? (
                <option value="">
                  Loading...
                </option>
              ) : (
                <option value="">select rep name</option>
                
              )}
              {/* <option value="All">All</option> */}
              {RbmListComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Brand Name
            </label>
            <select
              className="filter-style"
              id="brand"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeBrand(event)}
              value={selectedBrand}
            >
               <option value="">select brand</option>
               {/* <option value="All">All</option> */}
              {brandComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
          </div>
          
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
            }}
          >
            <button className="submit-btn" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div>
        <div>
          <button
            className="download-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />
            <CSVLink data={rows}  headers={columns_buh} filename={"ABM Brand Summary.csv"} style={{textDecoration:"none",color:"black"}}>Download</CSVLink>
          </button>
        </div>
      </div>
      {loader === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "150px",
          }}
        >
          <CircularProgress color="inherit" display={loader===true?"true":"false"} />
        </div>
      ):(
      <ABMSkuTable rows={rows} Month1={Month1} Month2={Month2} Month3={Month3}/>)}
         {loader === false ?(<div
          style={{
           
           height:"135px",
           width:"100%",
           marginBottom:"10px"
           
          }}
        >
        <table className='table-buh'>
    <tr className="table-tr-td-buh">
    <th className="table-tr-td-buh"></th>
      <th className="table-tr-td-buh">Adj.bud U ({Month1})</th>
      <th className="table-tr-td-buh">Adj.bud V ({Month1})</th>
      <th className="table-tr-td-buh">Adj.bud U ({Month2})</th>
      <th className="table-tr-td-buh">Adj.bud V ({Month2})</th>
      <th className="table-tr-td-buh">Adj.bud U ({Month3})</th>
      <th className="table-tr-td-buh">Adj.bud V ({Month3})</th>
      
    </tr>
    <tr className="table-tr-td-buh">
      <td className="table-tr-td-buh">Total</td>
      <td className="table-tr-td-buh">{filtersDataSum['m1_adj_unit']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m1_adj_val']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m2_adj_unit']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m2_adj_val']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m3_adj_unit']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['m3_adj_val']}</td>
    </tr>
  </table>
        </div>):""}
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
        autoHideDuration={6000}
      />
    </div>
  )
}

export default ABMSkuSummary
